/**
 * Created by lihanying on 2017/7/6.
 */
import { GETACCOUNTLIST, GETCLUBROLELIST, GETREGIONLIST } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETACCOUNTLIST:
      return Object.assign({}, state, { accountList: action.payload })
    case GETCLUBROLELIST:
      return Object.assign({}, state, { roleList: action.payload })
    case GETREGIONLIST:
      return Object.assign({}, state, { regionList: action.payload })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubUsers/reduce.js